<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<!-- rederizando componente alert -->
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Atendimentos de procedimento</b>
						</h3>
						<router-link tag="a" class="btn btn-primary pull-right" :to="'/administracao/agendas/novo-procedimento/' + $route.params.contratoId" v-if="hasPermission('usuario.write')"><span class="fa fa-plus"></span> Novo</router-link>
					</div>
					<div class="box-body">
						<cabecalho-contrato :contrato-id="$route.params.contratoId"></cabecalho-contrato>
						<form @submit.prevent="getDataTable()">
							<div class="row">
								<div class="col-sm-12">
									<label>Filtros: </label>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<input type="text" v-model="filtros.nome_procedimento" class="form-control" placeholder="Procedimento">
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<input type="text" v-model="filtros.nome_profissional" class="form-control" placeholder="Profissional">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<input type="number" v-model="filtros.idade_minima" class="form-control" placeholder="Idade Mínima">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<input type="number" v-model="filtros.idade_maxima" class="form-control" placeholder="Idade Máxima">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<select v-model="filtros.sexo" class="form-control">
											<option value="">--Sexo--</option>
											<option :value="SEXO.AMBOS">Ambos</option>
											<option :value="SEXO.MASCULINO">Masculino</option>
											<option :value="SEXO.FEMININO">Feminino</option>
										</select>
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<button class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
									</div>
								</div>
							</div>
						</form>
						<table class="table table-bordered table-hover table-striped">
							<thead>
							<tr>
								<th>Procedimento</th>
								<th>Profissional</th>
								<th>Sexo</th>
								<th>Idade Mínima</th>
								<th>Idade Máxima</th>
							</tr>
							</thead>
							<tbody>
							<tr @click="getAtendimentos(index, item)" class="even hand" :class="{'ativa': indexAtivo === index}" role="row" v-for="(item, index) in dataTable.data" :key="index">
								<td>{{ item.contrato_procedimento.procedimento.nome }}</td>
								<td>{{ item.profissional.nome }}</td>
								<td>{{ item.sexo | sexo }}</td>
								<td>{{ item.idade_minima }}</td>
								<td>{{ item.idade_maxima }}</td>
							</tr>
							</tbody>
						</table>
						<div class="row">
							<div class='col-sm-5'>
								Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
							</div>
							<div class='col-sm-7' style="text-align:right">
								<laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
									<span slot="prev-nav">&lt; Anterior</span>
									<span slot="next-nav">Próximo &gt;</span>
								</laravue-pagination>
							</div>
						</div>
						<br>
						<div v-show="indexAtivo != undefined">
						<div class="row">
							<div class="col-md-3">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span> Segunda-feira</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 1)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
														<span class="pull-right">
															<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
															</a>
														</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span> Terça-feira</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 2)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
															<span class="pull-right">
																		<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																			<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
																		</a>
															</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span> Quarta-feira</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 3)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
															<span class="pull-right">
																		<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																			<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
																		</a>
																	</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-3">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span> Quinta-feira</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 4)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
															<span class="pull-right">
																		<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																			<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
																		</a>
																	</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<!-- lado direito -->
							<div class="col-md-4">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span> Sexta-feira</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 5)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
															<span class="pull-right">
																		<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																			<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
																		</a>
																	</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-4">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span> Sábado</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 6)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
															<span class="pull-right">
																		<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																			<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
																		</a>
																	</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-4">
								<div class="panel panel-default">
									<div class="panel-heading">
										<h3 class="panel-title"><b><span class="fa fa-calendar-check-o"></span>Domingo</b></h3>
									</div>
									<div class="panel-body tamanho-fixo-box-agenda">
										<div v-for="(item, index) in atendimentos" :key="index">
											<div v-if="(item.dia == 0)">
												<div class="row">
													<div class="col-md-10">
														<a @dblclick="editar(item)" href="javascript:void(0)">{{item.hora_inicial}} às {{item.hora_final}} <br> {{item.quantidade_primeira}} P  |  {{item.quantidade_retorno}} R  |  {{item.quantidade_local}} L </a>
													</div>
													<div class="col-md-2">
															<span class="pull-right">
																		<a title="Excluir atendimento" @click="deletar(item, index)" href="javascript:void(0)">
																			<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
																		</a>
																	</span>
													</div>
												</div>
												<hr>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						</div>
					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button class="btn btn-default pull-left" @click="$router.go(-1)"> <i class="fa fa-reply"></i> Voltar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal-editar-procedimento-atendimento :atendimento="atendimento" :show="showModalEditarProcedimento" @close="showModalEditarProcedimento = false" @atendimentoProcedimentoAtualizado="(procedimento)=>{atendimentoProcedimentoAtualizado(procedimento)}"></modal-editar-procedimento-atendimento>
	</section>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	import modalEditarProcedimentoAtendimento from "./modalEditarProcedimentoAtendimento";
	import cabecalhoContrato from "../contratos/cabecarioContrato";
	import {
		SEXO
	} from "@/constants";
	export default {
		filters: {
			sexo(val) {
				switch (val) {
					case 0:
						return 'Ambos';
					case 1:
						return 'Masculino';
					case 2:
						return 'Feminino';
				}
			}
		},
		computed: {
			SEXO: function() {
				return SEXO;
			}
		},
		data: () => ({
			currentPage: undefined,
			showModalEditarProcedimento: false,
			dataTable: {},
			indexAtivo: undefined,
			atendimentos: [],
			atendimento: {
				contrato_procedimento: {
					procedimento: {
						nome: ''
					}
				},
				hora_final: '',
				hora_inicial: '',
				idade_maxima: '',
				idade_minima: '',
				profissional: {
					nome: ''
				},
				quantidade_local: '',
				quantidade_primeira: '',
				quantidade_retorno: '',
				sexo: '',
			},
			filtros: {
				nome_profissional: '',
				nome_procedimento: '',
				sexo: '',
				idade_maxima: '',
				idade_minima: ''
			}
		}),
		mounted() {
			this.getDataTable();
		},
		methods: {
			getDataTable(page, limpar) {
				if (typeof page === 'undefined') {
					page = 1;
				}
				this.currentPage = page;
				this.filtros.page = page;
				this.filtros.id = this.$route.params.contratoId;
				this.$store.commit('TOGGLE_LOADING');

				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;

				axios.get(`${this.$store.state.serverURI}/api/administracao/agendas/getAllPaginateProcedimentos`, config)
					.then(response => {
						this.dataTable = response.data;
						if (typeof limpar === 'undefined') {
							this.atendimentos = [];
							this.indexAtivo = undefined;
						}
						this.$store.commit('TOGGLE_LOADING');
					}).catch((error) => {
					console.log(error);
				});
			},
			getAtendimentos(index, item) {
				this.$swal({
					title: "Aguarde...",
					imageUrl: "/static/img/Rolling-green.gif",
					showConfirmButton: false,
					allowOutsideClick: false
				});
				this.indexAtivo = index;
				axios.post(`${this.$store.state.serverURI}/api/administracao/agendas/getProcedimentoAtendimentos`, item, this.$store.getters.getHeaderAuth)
					.then(response => {
						this.atendimentos = response.data;
						this.$swal.close();
					}).catch((error) => {
					this.$swal.close();
					console.log(error);
				});
			},
			editar(item) {
				this.atendimento = this.clonar(item);
				this.showModalEditarProcedimento = true;
			},
			deletar(item, index) {
				this.$swal({
					title: 'Excluir este atendimento?',
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
					cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						this.$swal({
							title: "Aguarde...",
							imageUrl: "/static/img/Rolling-green.gif",
							showConfirmButton: false,
							allowOutsideClick: false
						});
						axios.delete(`${this.$store.state.serverURI}/api/administracao/agendas/deleteProcedimentoAtendimento/${item.id}`, this.$store.getters.getHeaderAuth)
							.then(response => {
								this.atendimentos.splice(index, 1)
								this.$swal({
									type: "success",
									title: "Atendimento deletado com sucesso!",
									showConfirmButton: false,
									timer: 1500
								});
							}).catch((error) => {
							console.log(error);
						});
					}
				});
			},
			atendimentoProcedimentoAtualizado(procedimento) {
				this.showModalEditarProcedimento = false;
				axios.post(`${this.$store.state.serverURI}/api/administracao/agendas/getProcedimentoAtendimentos`, procedimento, this.$store.getters.getHeaderAuth)
					.then(response => {
						this.atendimentos = response.data;
					}).catch((error) => {
					console.log(error);
				});
				this.getDataTable(this.currentPage, false);
			},
			clonar(obj) {
				if (obj == null || typeof obj != 'object') {
					return obj;
				}

				var temp = new obj.constructor();
				for (var key in obj) {
					temp[key] = this.clonar(obj[key]);
				}

				return temp;
			}
		},
		watch: {},
		components: {
			modalEditarProcedimentoAtendimento,
			cabecalhoContrato
		}
	};
</script>

<style scoped>
	.tamanho-fixo-box-agenda {
		display: block;
		height: 250px;
		overflow-y: auto;
	}

	.ativa {
		background-color: #757575 !important;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// agendasProcedimentos.vue?0c989862